var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, P, PacemEventTarget, Watch, PropertyConverters, Utils, LogLevel } from './_default-imports';
import { DefaultComparer } from '../../comparers';
import { HistoryService } from '@pacem/pacem-foundation';
export class StateEvent extends CustomEvent {
    constructor(type, detail) {
        super(type, { detail });
    }
}
let PacemHistoryElement = class PacemHistoryElement extends PacemEventTarget {
    #history;
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        switch (name) {
            case 'state':
                this._handleStateChange(val);
                break;
            case 'maxlength':
                const h = this.#history;
                if (!Utils.isNull(h)) {
                    h.maxlength = val;
                }
                break;
        }
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this._handleStateChange();
    }
    _handleStateChange(val = this.state) {
        const history = this.#history;
        if (!Utils.isNull(history)) {
            if (DefaultComparer(history.current, val) !== true) {
                history.push(val);
                this.log(LogLevel.Log, 'Pushed state.');
                this._synchronize('push');
            }
        }
        else {
            this.#history = new HistoryService(val, this.maxlength);
        }
    }
    redo() {
        const h = this.#history;
        if (!Utils.isNull(h)) {
            h.redo();
            this.log(LogLevel.Log, 'Redone state.');
            this._synchronize('redo');
        }
    }
    reset() {
        const h = this.#history;
        if (!Utils.isNull(h)) {
            h.reset();
            this.log(LogLevel.Log, 'Reset state.');
            this._synchronize('reset');
        }
    }
    undo() {
        const h = this.#history;
        if (!Utils.isNull(h)) {
            h.undo();
            this.log(LogLevel.Log, 'Undone state.');
            this._synchronize('undo');
        }
    }
    _synchronize(type) {
        const h = this.#history;
        this.canUndo = h.canUndo;
        this.canRedo = h.canRedo;
        this.state = h.current;
        const { canRedo, canUndo, current: state } = h;
        this.dispatchEvent(new StateEvent(type, { canRedo, canUndo, state }));
    }
};
__decorate([
    Watch({ emit: true, converter: PropertyConverters.Json })
], PacemHistoryElement.prototype, "state", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemHistoryElement.prototype, "maxlength", void 0);
__decorate([
    Watch({ emit: true, converter: PropertyConverters.Boolean })
], PacemHistoryElement.prototype, "canUndo", void 0);
__decorate([
    Watch({ emit: true, converter: PropertyConverters.Boolean })
], PacemHistoryElement.prototype, "canRedo", void 0);
PacemHistoryElement = __decorate([
    CustomElement({ tagName: P + '-history' })
], PacemHistoryElement);
export { PacemHistoryElement };
//}
